/**
 * API base URL resolver. Uses VITE_API_URL for both SSR and browser so
 * the same value works in dev (localhost), in Cloudflare Workers SSR
 * (where there's no localhost API), and in the browser bundle.
 *
 * Default differs by build mode so a `vite build` that runs without an
 * env file (e.g. CI, fresh dev machine) doesn't silently bake
 * `http://localhost:5050` into the production bundle — which is what
 * caused the prod home page to render 403s after a Worker deploy.
 * Matches the same isDev/prod fallback already used in `server.ts`.
 */
export function apiBase(): string {
  const explicit = import.meta.env.VITE_API_URL;
  if (explicit) return explicit;
  return import.meta.env.DEV ? "http://localhost:5050" : "https://api.majourneys.com";
}

/**
 * Absolute API URL. Some libraries (better-auth, Eden Treaty) reject
 * relative paths and require a full origin. Resolves against
 * `window.location.origin` when needed.
 */
export function apiBaseAbsolute(): string {
  const base = apiBase();
  if (/^https?:\/\//i.test(base)) return base;
  if (typeof window !== "undefined") {
    return new URL(base, window.location.origin).toString().replace(/\/$/, "");
  }
  return "http://localhost:5050";
}

/** Standard headers for raw fetches against the API. */
export function apiHeaders(extra?: HeadersInit): Headers {
  return new Headers(extra);
}
